var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09428 3.64168C6.84019 3.1335 6.32079 2.8125 5.75264 2.8125H4.3125C3.48407 2.8125 2.8125 3.48407 2.8125 4.3125V4.35938C2.8125 10.3396 7.66042 15.1875 13.6406 15.1875H13.6875C14.5159 15.1875 15.1875 14.5159 15.1875 13.6875V12.2474C15.1875 11.6792 14.8665 11.1598 14.3583 10.9057L12.8601 10.1566C12.4025 9.92779 11.8497 10.0175 11.4879 10.3793C11.1516 10.7156 10.6431 10.8267 10.2188 10.612C8.93109 9.96019 8.03981 9.06891 7.38802 7.78119C7.17326 7.3569 7.28443 6.84838 7.62069 6.51212C7.98251 6.1503 8.07221 5.59755 7.84338 5.13988L7.09428 3.64168Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1bdee3f0a35c99c44928c7f7997b9c0b.svg";
export { ForwardRef as ReactComponent };